import ListPage from './ListPage.container';
import CreatePage from './CreatePage';
import EditPage from './EditPage';

export default {
  ListPage,
  CreatePage,
  EditPage
};
